import React, {Component} from 'react';
import Api from "../utils/Api";
import MenuBar from "./MenuBar";
import UserNav from "./UserNav";
import Footer from "./Footer";
import SupportedLanguages from '../utils/entities/SupportedLanguages';
import MachineContainer from "../pages/machines/MachineContainer";
import UserData from "../utils/entities/UserData";
import CompanySelector from "../globalComponents/CompanySelector";
import Companies from "../utils/entities/Companies";
import HomeContainer from "../pages/home/HomeContainer";
import AnalysisContainer from "../pages/analysis/AnalysisContainer";
import ServiceContainer from "../pages/service/ServiceContainer";
import AcademyContainer from "../pages/academy/AcademyContainer";
import SoftwareContainer from "../pages/software/SoftwareContainer";
import AccessoriesContainer from "../pages/accessories/AccessoriesContainer";
import ReportContainer from "../pages/reports/ReportContainer";
import Machines from "../utils/entities/Machines";
import Shifts from "../utils/entities/Shifts";
import momentTimezone from 'moment-timezone';
import moment from "moment";
import SetupContainer from "../pages/setup/SetupContainer";
import DesignContainer from "../pages/designs/DesignContainer";
import AlarmContainer from "../pages/alarms/AlarmContainer";
import VideoArchivContainer from "../pages/video/VideoArchivContainer";
import VideoCategoryData from "../utils/entities/VideoCategoryData";
import VideoCategoryList from "../utils/entities/VideoCategoryList";
import VideoList from "../utils/entities/VideoList";
import ExpireWarningHandle from "../utils/ExpireWarningHandle";
import Modal from "../utils/entities/Modal";
import UserContainer from "../pages/user/UserContainer";
import ErrorPageContainer from "../pages/errors/ErrorPageContainer";
import AdminContainer from "../pages/admin/AdminContainer";
import CompaniesContainer from "../pages/admin/CompaniesContainer";
import UsersContainer from "../pages/admin/UsersContainer";
import LocationContainer from "../pages/admin/LocationContainer";
import LicenceContainer from "../pages/admin/LicenceContainer";
import MachinesContainer from "../pages/admin/MachinesContainer";
import OperatorContainer from "../pages/admin/OperatorContainer";
import OperatorTokenContainer from "../pages/admin/OperatorTokenContainer";
import DataCollectorContainer from "../pages/admin/DataCollectorContainer";
import OldDataContainer from "../pages/admin/OldDataContainer";
import SensorsContainer from "../pages/admin/SensorsContainer";
import TranslationContainer from "../pages/translation/TranslationContainer";
import TreeStructureContainer from "../pages/admin/TreeStructureContainer";
import LogFilesContainer from "../pages/admin/LogFilesContainer";
import RawDataContainer from "../pages/admin/RawDataContainer";
import ApiOverviewContainer from "../pages/api/ApiOverviewContainer";
import InfoBanner from "./InfoBanner";

import "./Navigation.css";
import "../css/machines.css";

class MainFrame extends Component {

    constructor(props) {

        super(props);

        /**   @type {Api}   */
        this.api = new Api();

        this.state = {
            activePage: 'home',
            activePageChanged: 0,
            activeVideoCategory: null,
            pastTimeOfInactivity: 0,
            oldActivePage: '',
            UserData: new UserData(),
            companies: new Companies(),
            Machines: new Machines(),
            Shifts: new Shifts(),
            companyLocations: [],
            notifications: [],
            Locations: [],
            videoCategories: null,
            videos: null,
            session: null,
            timezone: 'UTC', // override default by requestUserData
            modalData: null,
        };

        this.moduleWarningStartDays = 30;

        this.saveSettings = this.saveSettings.bind(this);
        this.requestSession = this.requestSession.bind(this);
        this.requestMachines = this.requestMachines.bind(this);
        this.requestCompanyLocations = this.requestCompanyLocations.bind(this);
        this.requestUserData = this.requestUserData.bind(this);
        this.requestShifts = this.requestShifts.bind(this);
        this.requestNotifications = this.requestNotifications.bind(this);
        this.setCurrentCompany = this.setCurrentCompany.bind(this);
        this.setHideMachinesAfterPastTime = this.setHideMachinesAfterPastTime.bind(this);
        this.pageNavigation = this.pageNavigation.bind(this);
        this.handleNavigation = this.handleNavigation.bind(this);
        this.handleNavigate = this.handleNavigate.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.setNewActiveVideoCategory = this.setNewActiveVideoCategory.bind(this);
        this.resetActiveVideoCategory = this.resetActiveVideoCategory.bind(this);
        this.requestVideoCategories = this.requestVideoCategories.bind(this);
        this.requestVideos = this.requestVideos.bind(this);
        this.getStatusCase = this.getStatusCase.bind(this);
        this.setModalData = this.setModalData.bind(this);
        this.setMachineHideTime = this.setMachineHideTime.bind(this);
        this.getBaseData = this.getBaseData.bind(this);
        this.checkUserRole = this.checkUserRole.bind(this);

        this.requestVideoCategories();
        this.requestVideos();

        this.requestNotifications();
        //this.requestNotificationsJob = new Job(this.requestNotifications, 10000);

    }

    componentWillMount() {

        document.body.style.backgroundColor = "white";

        // Diverse Basisdaten laden
        this.requestSession();
        this.requestUserData();
        this.requestCompanies();
        this.requestLocations();
        //this.requestMachines();
        this.requestCompanyLocations();
        this.requestShifts();

        //this.requestNotificationsJob.start(true);

    }

    componentWillUnmount() {

        document.body.style.backgroundColor = null;

        //this.requestNotificationsJob.stop();

    }

    requestSession() {

        const callback = function(res) {
            if (res) {
                this.setState({session: res});
            }
        }.bind(this);

        this.api.request('GetSession', {}, callback, null);

    }

    requestMachines() {

        const cc = (this.state.companies && this.state.companies.initialized) ? this.state.companies.getCurrentCompany() : null;
        const idCompany = cc ? +(cc.id) : null;

        if (idCompany === null) {
            window.setTimeout(this.requestMachines, 100);

            return;
        }

        const params = {
            id_company: idCompany,
            id_user: this.state.UserData.id,
            pastTimeOfInactivity: this.state.pastTimeOfInactivity
        };

        const callback = function(res) {
            if (res) {
                this.setState({Machines: new Machines(res)});
            }
        }.bind(this);

        this.api.request('GetMachines', params, callback, null);

    }

    requestCompanyLocations() {

        const cc = (this.state.companies && this.state.companies.initialized) ? this.state.companies.getCurrentCompany() : null;
        const idCompany = cc ? +(cc.id) : null;

        if (idCompany === null) {
            window.setTimeout(this.requestCompanyLocations, 100);

            return;
        }

        const callback = function(res) {
            if (res) {
                this.setState({companyLocations: res});
            }
        }.bind(this);

        this.api.request('GetCompanyLocations', {companyId: idCompany}, callback, null);

    }

    requestShifts() {

        const cc = (this.state.companies && this.state.companies.initialized) ? this.state.companies.getCurrentCompany() : null;
        const idCompany = cc ? +(cc.id) : null;

        if (idCompany === null) {
            window.setTimeout(this.requestShifts, 100);

            return;
        }

        const callback = function(res) {
            if (res) {
                this.setState({Shifts: new Shifts(res)});
            }
        }.bind(this);

        this.api.request('GetWorkPeriods', {id_company: idCompany}, callback, null);

    }

    requestUserData() {
        const callback = function(res) {
            if (res) {
                const ud = new UserData(res);
                if (this.props.getCurrentLanguageData) {
                    const data = this.props.getCurrentLanguageData(ud.language);
                    ud.formats = data.formats;
                }

                const newState = { UserData: ud };
                if (this.state.companies.initialized) {
                    const companies = this.state.companies.clone();
                    companies.initActiveCompany(ud);
                    newState.companies = companies;

                    // Re-trigger dependent requests to ensure they use the correct company
                    this.requestMachines();
                    this.requestCompanyLocations();
                    this.requestShifts();
                }

                this.setState(newState, this.setHideMachinesAfterPastTime);

                // check, if timezone-data is set
                if (this.props.Timezones) {
                    const found = this.props.Timezones.filter((tz) => {
                        return String(tz).toLowerCase() === String(ud.timezone).toLowerCase();
                    });

                    if (found.length === 0) {
                        const tzGuess = momentTimezone.tz.guess();
                        this.saveSettings('timezone', tzGuess);
                    }
                }
            }
        }.bind(this);

        this.api.request('GetUserData', null, callback, null);
    }

    requestNotifications() {

        const callback = function(res) {
            if (res) {
                this.setState({notifications: res});
            }
        }.bind(this);

        this.api.request('GetNotifications', {action: 'getOverview'}, callback, null);

    }

    requestCompanies() {
        const callback = function(res) {
            if (res) {
                const companies = new Companies(res, null);

                if (this.state.UserData.initialized) {
                    companies.initActiveCompany(this.state.UserData);
                }

                this.setState({ companies }, () => {
                    // Re-trigger dependent requests to ensure they use the correct company
                    this.requestMachines();
                    this.requestCompanyLocations();
                    this.requestShifts();
                });
            }
        }.bind(this);

        this.api.request('GetCompanies', null, callback, null);
    }

    requestLocations() {

        const callback = function(res) {
            if (res) {
                this.setState({
                    Locations: res
                });
            }
        }.bind(this);

        this.api.request('GetLocations', null, callback, null);

    }

    requestVideoCategories() {

        const callback = function(res) {
            if (res) {
                this.setState({
                    videoCategories: new VideoCategoryList(res),
                });
            }
        }.bind(this);

        this.api.request('GetVideoCategories', {filter: {}}, callback, null);

    }

    requestVideos() {

        const callback = function(res) {
            if (res) {
                this.setState({
                    videos: new VideoList(res),
                });
            }
        }.bind(this);

        this.api.request('GetVideos', {filter: {}}, callback, null);

    }

    setCurrentCompany(companyId) {

        const companies = this.state.companies.clone();
        companies.setCurrentCompany(companyId);

        this.setState({
            companies: companies,
            Machines: new Machines(),
            Shifts: new Shifts()
        });

        // save to settings
        this.saveSettings('selectedCompany', companyId);
        this.saveSettings('viewLocation', 0);

        // re-request machines, Shifts and Company-Locations
        this.requestMachines();
        this.requestCompanyLocations();
        this.requestShifts();
        this.requestUserData();

    }

    setHideMachinesAfterPastTime() {

        const settings = this.state.UserData ? this.state.UserData.settings : {};
        const state = {...this.state};

        //  Maschinen-Inaktivität aus den userprops laden
        const pastTimeOfInactivity = (settings.hideMachinesAfterPastTime) ? settings.hideMachinesAfterPastTime : 0;

        if (pastTimeOfInactivity) state.pastTimeOfInactivity = parseInt(pastTimeOfInactivity);

        this.setState(state);

    }

    /** save setting to Database */
    saveSettings(key, value) {

        const ud = {...this.state.UserData};
        const params = {key: key, value: value};

        if (!ud.initialized) return;

        if (key === 'remove') {
            const pKey = (value.hasOwnProperty('key')) ? value.key : null;

            if (pKey && ud.settings.hasOwnProperty(pKey))  delete ud.settings[pKey];
        } else if (key === 'timezone') {
            params.companyId = this.state.companies.currentCompany.id;

            ud.timezone = value;
            const companies = this.state.companies.clone();
            companies.updateActiveCompanyTimezone(value);
            this.setState({companies: companies});
        } else if (key === 'reports') {
            const pReport = (value.hasOwnProperty('report')) ? value.report : null;
            const pKey = (value.hasOwnProperty('key')) ? value.key : null;
            const pVal = (value.hasOwnProperty('value')) ? value.value : null;

            if (pReport && pKey && pVal) {
                if (!ud.settings.hasOwnProperty('reports')) ud.settings.reports = {};
                if (!ud.settings.reports.hasOwnProperty(pReport)) ud.settings.reports[pReport] = {};

                ud.settings.reports[pReport][pKey] = pVal;
            }
        } else if (key === 'rpm') {
            params.companyId = this.state.companies.currentCompany.id;

            ud.settings[key] = value;
        } else {
            if (ud.settings[key] && ud.settings[key] === value) return;

            ud.settings[key] = value;
        }

        this.setState({UserData: ud});

        // update DB
        this.api.request('SaveSettings', params, (res) => {
            // We overwrite the user with callback
            const nud = new UserData(res);

            this.setState({UserData: nud});
        }, null);

    }

    getBaseData() {

        return {
            userData: this.state.UserData,
            companies: this.state.companies,
            companyLocations: this.state.companyLocations,
            locations: this.state.Locations,
            session: this.state.session,
            shifts: this.state.Shifts,
            timezone: this.state.timezone,
            translate: this.props.translate,
            i18n: this.props.i18n,
            browser: this.props.browser,
            package: this.props.package,
            languages: new SupportedLanguages(),
            saveSettings: this.saveSettings,
            requestUserData: this.requestUserData,
            requestCompanies: this.requestCompanies,
            modalData: this.setModalData,
            closeModal: this.handleCloseModal,
            checkUserRole: this.checkUserRole,
            pageNavigation: this.pageNavigation,
        };

    }

    setNewActiveVideoCategory(categoryId) {

        const filter = {
            category_id: categoryId,
        };

        const callback = function(res) {
            if (res) {
                this.setState({activeVideoCategory: new VideoCategoryData(res)});
            }
        }.bind(this);

        this.api.request('GetVideoCategories', {filter: filter}, callback, null);

    }

    resetActiveVideoCategory() {

        this.setState({activeVideoCategory: null});

    }

    getStatusCase(section, itemTag) {

        const timeNow = Date.now();
        const momentNow = moment();
        const momentShortly = momentNow.clone().add(this.moduleWarningStartDays, 'days');
        const userRights = this.state.UserData['rights'];

        let statusCase = 'locked';

        if (typeof userRights !== 'undefined' &&
            typeof userRights[section] !== 'undefined' &&
            typeof userRights[section][itemTag] !== 'undefined') {
            const userRight = userRights[section][itemTag];
            const momentExpires = moment(+userRight['dateEnd']);

            if (userRight['dateEnd'] !== null && userRight['dateEnd'] <= timeNow) {
                statusCase = 'expired';
            } else if (userRight['dateEnd'] !== null && momentShortly.isAfter(momentExpires)) {
                statusCase = 'shortly';
            } else if (userRight['dateStart'] !== null && userRight['dateStart'] > timeNow) {
                statusCase = 'soon';
            } else if (userRight['state'] === 'active') {
                statusCase = 'ok';
            }
        }

        return statusCase;

    }

    getModulStatusCases() {

        const timeNow = Date.now();
        const momentNow = moment();
        const momentShortly = momentNow.clone().add(this.moduleWarningStartDays, 'days');
        const userRights = this.state.UserData['rights'];

        let statusCases = {};

        statusCases['Product-home'] = 'ok';

        if (typeof userRights !== undefined) {
            for (let section in userRights) {
                for (let rightTag in userRights[section]) {
                    const rights = userRights[section][rightTag];
                    const momentExpires = moment(+rights['dateEnd']);

                    if (rights['state'] !== 'active') {
                        statusCases[section + '-' + rightTag] = 'locked';
                    } else if (rights['dateEnd'] !== null && rights['dateEnd'] <= timeNow) {
                        statusCases[section + '-' + rightTag] = 'expired';
                    } else if (rights['dateEnd'] !== null && momentShortly.isAfter(momentExpires)) {
                        statusCases[section + '-' + rightTag] = 'shortly';
                    } else if (rights['dateStart'] !== null && rights['dateStart'] > timeNow) {
                        statusCases[section + '-' + rightTag] = 'soon';
                    } else {
                        statusCases[section + '-' + rightTag] = 'ok';
                    }
                }
            }
        }

        return statusCases;

    }

    pageNavigation(page) {

        const oldActivePage = this.state.activePage;

        this.setState({
            activePage: page,
            activePageChanged: this.state.activePageChanged + 1,
            oldActivePage: oldActivePage,
            modalData: null,
        });

    }

    handleNavigation(page) {

        const oldActivePage = this.state.activePage;

        this.setState({
            activePage: page,
            activePageChanged: this.state.activePageChanged + 1,
            oldActivePage: oldActivePage,
            modalData: null,
        });

    }

    handleNavigate(event, linkTo) {

        if (this.props.handleNavigation) {
            event.preventDefault();

            this.props.handleNavigation(linkTo);
        }

        return null;

    }

    handleCloseModal() {

        this.setState({
            modalData: null,
        });

    }

    checkPageRights(page) {

        const checkProduct = this.getStatusCase('Product', page);
        const checkModul = this.getStatusCase('Module', page);
        const checkResult = (checkProduct === 'ok' || checkModul === 'ok') ? 'ok' : 'locked';

        let status = (checkResult === 'ok');

        switch (page) {
            case 'home':
            case 'userSettings':
            case 'api':
                status = true;
                break;

            case 'translations':
                status = this.checkUserRole('translations');
                break;

            case 'adminCompanies':      //  Punkt 2
            case 'adminOldData':        //  Punkt 9
                status = (this.checkUserRole('superadmin') || this.checkUserRole('zskadmin'));
                break;

            case 'adminTreeStructure':  //  Punkt 10
            case 'adminSensors':        //  Punkt 11
            case 'adminLogs':			//	Punkt 12
                status = this.checkUserRole('superadmin');
                break;

            case 'setup':
            case 'admin':
            case 'adminLicence':        //  Punkt 1
            case 'adminLocations':      //  Punkt 3
			case 'adminMachines':       //  Punkt 4
            case 'adminUsers':          //  Punkt 5
            case 'adminOperator':       //  Punkt 6
            case 'adminOperatorToken':  //  Punkt 7
            case 'adminDatacollector':  //  Punkt 8
            case 'adminRawData':
                status = (this.checkUserRole('superadmin') || this.checkUserRole('zskadmin') || this.checkUserRole('companyadmin'));
                break;
        }

        return status;

    }

    checkUserRole(role) {

        const user = this.state.UserData;

        if (user.initialized && user.roles) return user.roles.includes(role.toLowerCase());

        return false;

    }

    setModalData(modalData) {

        this.setState({
            modalData,
        });

    }

    setMachineHideTime(pastTimeOfInactivity) {

        this.saveSettings('hideMachinesAfterPastTime', pastTimeOfInactivity);

        this.setState({
            pastTimeOfInactivity: parseInt(pastTimeOfInactivity)
        }, this.requestMachines);

    }

    getModalData() {

        if (!this.state.modalData) return null;
        if (!this.state.modalData.content) return null;

        return (
            <Modal
                content={this.state.modalData.content}
                backgroundImage={this.state.modalData.backgroundImage}
                height={this.state.modalData.height}
                width={this.state.modalData.width}
                onClose={() => this.setState({modalData: null})}
            />
        );

    }

    render() {

        const videoCategoryList = (this.state.videoCategories) ? this.state.videoCategories : {};
        const videoList = (this.state.videos) ? this.state.videos : {};
        const modulStatusCases = this.getModulStatusCases();
        const baseData = this.getBaseData();
        const timezones = (this.props.Timezones) ? this.props.Timezones : [];
        const modal = this.getModalData();

        const messageKey = null;
        const messageText = null;

        const menuEntries = {
            home: {
                nameKey: 'home',
                page: <HomeContainer
                    baseData={baseData}
                    notifications={this.state.notifications}
                />
            },
            userSettings: {
                nameKey: 'user',
                page: <UserContainer
                    baseData={baseData}
                    timezones={timezones}
                    requestUserData={this.requestUserData}
                />
            },
            analysis: {
                name: 'MY.Analysis',
                page: <AnalysisContainer
                    baseData={baseData}
                />
            },
            machines: {
                nameKey: 'machines',
                page: <MachineContainer
                    baseData={baseData}
                    machines={this.state.Machines}
                    pastTimeOfInactivity={this.state.pastTimeOfInactivity}
                    setMachineHideTime={this.setMachineHideTime}
                    requestMachines={this.requestMachines}
                />
            },
            reports: {
                nameKey: 'reports',
                page: <ReportContainer
                    baseData={baseData}
                    machines={this.state.Machines}
                    activePageChanged={this.state.activePageChanged}
                />
            },
            designs: {
                nameKey: 'designs',
                page: <DesignContainer
                    baseData={baseData}
                />
            },
            setup: {
                nameKey: 'setup',
                page: <SetupContainer
                    baseData={baseData}
                    companies={this.state.companies}
                    timezones={timezones}
                    requestShifts={this.requestShifts}
                />
            },
            alarms: {
                nameKey: 'alarms',
                page: <AlarmContainer
                    baseData={baseData}
                    notifications={this.state.notifications}
                />
            },
            service: {
                name: 'MY.Service',
                page: <ServiceContainer
                    baseData={baseData}
                />
            },
            academy: {
                name: 'MY.Academy',
                page: <ServiceContainer
                    baseData={baseData}
                />
            },
            video: {
                name: 'MY.Video',
                page: <VideoArchivContainer
                    key="videoFree"
                    baseData={baseData}
                    categoryList={videoCategoryList}
                    videoList={videoList}
                    videoSource="YouTube"
                    handleStatusCase={this.getStatusCase.bind(this)}
                    handleStateChange={this.setNewActiveVideoCategory}
                    updateVideoCategories={this.requestVideoCategories}
                    updateVideoList={this.requestVideos}
                />
            },
            videoFree: {
                name: 'Free',
                nameKey: 'videos',
                page: <VideoArchivContainer
                    key="videoFree"
                    baseData={baseData}
                    categoryList={videoCategoryList}
                    videoList={videoList}
                    videoSource="YouTube"
                    handleStatusCase={this.getStatusCase.bind(this)}
                    handleStateChange={this.setNewActiveVideoCategory}
                    updateVideoCategories={this.requestVideoCategories}
                    updateVideoList={this.requestVideos}
                />
            },
            videoPayment: {
                name: 'Payment',
                nameKey: 'videos',
                page: <VideoArchivContainer
                    key="videoPayment"
                    baseData={baseData}
                    categoryList={videoCategoryList}
                    videoList={videoList}
                    videoSource="Vimeo"
                    handleStatusCase={this.getStatusCase.bind(this)}
                    handleStateChange={this.setNewActiveVideoCategory}
                    updateVideoCategories={this.requestVideoCategories}
                    updateVideoList={this.requestVideos}
                />
            },
            software: {
                name: 'MY.Software',
                page: <SoftwareContainer
                    key="videoFree"
                    baseData={baseData}
                    videoSource="YouTube"
                    handleStatusCase={this.getStatusCase.bind(this)}
                    handleStateChange={this.setNewActiveVideoCategory}
                />
            },
            accessories: {
                name: 'MY.Accessories',
                page: <AccessoriesContainer
                    baseData={baseData}
                />
            },
            translations: {
                nameKey: 'translations',
                page: <TranslationContainer
                    baseData={baseData}
                />
            },
            admin: {
                name: 'MY.Admin',
                page: <AdminContainer
                    baseData={baseData}
                />
            },
            adminCompanies: {
                nameKey: 'companies',
                page: <CompaniesContainer
                    baseData={baseData}
                    timezones={timezones}
                />
            },
            adminLicence: {
                nameKey: 'licence',
                page: <LicenceContainer
                    baseData={baseData}
                />
            },
            adminLocations: {
                nameKey: 'locations',
                page: <LocationContainer
                    baseData={baseData}
                />
            },
            adminMachines: {
                nameKey: 'machines',
                page: <MachinesContainer
                    baseData={baseData}
                    machines={this.state.Machines}
                />
            },
            adminUsers: {
                nameKey: 'user',
                page: <UsersContainer
                    baseData={baseData}
                />
            },
            adminOperator: {
                nameKey: 'operator',
                page: <OperatorContainer
                    baseData={baseData}
                />
            },
            adminOperatorToken: {
                nameKey: 'operatorToken',
                page: <OperatorTokenContainer
                    baseData={baseData}
                />
            },
            adminDatacollector: {
                nameKey: 'dataCollector',
                page: <DataCollectorContainer
                    baseData={baseData}
                />
            },
            adminOldData: {
                nameKey: 'oldData',
                page: <OldDataContainer
                    baseData={baseData}
                />
            },
            adminTreeStructure: {
                nameKey: 'treeStructure',
                page: <TreeStructureContainer
                    baseData={baseData}
                />
            },
            adminSensors: {
                nameKey: 'sensors',
                page: <SensorsContainer
                    baseData={baseData}
                />
            },
            adminLogs: {
                nameKey: 'logFiles',
                page: <LogFilesContainer
                        baseData={baseData}
                />
            },
            adminRawData: {
                nameKey: 'rawData',
                page: <RawDataContainer
                    baseData={baseData}
                    machines={this.state.Machines}
                />
            },
            api: {
                name: 'API',
                page: <ApiOverviewContainer
                        baseData={baseData}
                />
            },
        };

        // current page and Breadcrumbs
        let infoBanner = null;
        let contentPage = null;
        let breadcrumbs = null;

        for (let ix in menuEntries) {
            if (ix !== this.state.activePage) continue;

            let entry = menuEntries[ix];

            if (entry.hasOwnProperty('page')) contentPage = entry.page;

            if (entry.hasOwnProperty('name') || entry.hasOwnProperty('nameKey')) {
                breadcrumbs = <div className="modulname">
                    <img src={require('../img/nav/home-default.svg').default} alt="MZ.ZSK"/>

                    <h1 style={{color: '#fff', margin: '0 0 5px'}}>{(entry.hasOwnProperty('name')) ? entry.name : baseData.translate(entry.nameKey)}</h1>
                </div>;
            }

            if (!this.checkPageRights(ix)) contentPage = <ErrorPageContainer baseData={baseData} code={401} />;

            break;
        }

        if(!this.state.UserData.initialized) return null;

        const contentClasses = ['contentPage', this.state.activePage].join(' ').trim();

        return (
            <div className={contentClasses}>
                {/*<!-- Hauptnavigationsleiste links -->*/}
                <MenuBar
                    baseData={baseData}
                    activePage={this.state.activePage}
                    modulStatusCases={modulStatusCases}
                    handleStatusCase={this.getStatusCase.bind(this)}
                    handleNavigation={this.handleNavigation}
                />
                {/*<!-- / Hauptnavigationsleiste links -->*/}

                {/*<!-- / fadeInComponents komponente-->*/}
                <div className="fadeInComponents animate-in" style={{backgroundColor: "white"}}>
                    {/*<!-- Headline Seitenmodul -->*/}
                    <div className="topbar">
                        {breadcrumbs}

                        <div className="locationBox">
                            <CompanySelector
                                baseData={baseData}
                                Companies={this.state.companies}
                                SetCurrentCompany={this.setCurrentCompany}
                            />
                        </div>
                    </div>
                    {/*<!-- / Headline Seitenmodul -->*/}

                    <div className="clearfix"/>

                    {/*<!-- Usernav -->*/}
                    <UserNav
                        baseData={baseData}
                        notifications={this.state.notifications}
                    />
                    {/*<!-- /Usernav -->*/}

                    <div className="contentarea">
                        <div className="modulWarning">
                            <ExpireWarningHandle
                                baseData={baseData}
                                warningStartDays={this.moduleWarningStartDays}
                            />
                        </div>

                        <div className="display">
                            <InfoBanner
                                baseData={baseData}
                                messageKey={messageKey}
                                messageText={messageText}
                            />

                            {contentPage}
                        </div>
                    </div>

                    <div className="clearfix"/>

                    <div className="bottomdiff" style={{display: 'none'}}/>

                    <Footer/>

                    {modal}
                </div>
            </div>
        );

    }

}

export default MainFrame;
